/**
 * Where a link opened into the running Hub app should go (manifest `launch_handler` is
 * `focus-existing`: a Hub link clicked in Slack, WhatsApp or another page brings the open Hub
 * window forward and hands it the link instead of opening a second window). Pure rules; see
 * AppLinkHandler.tsx.
 *
 * Returns the in-app path to open, or null to only bring Hub forward: another site, the page
 * already open, or a plain launch from the app icon (the start URL `/`), which must never pull an
 * operator off what they are doing.
 */
export const appLinkTarget = (targetUrl: string, origin: string, current: string) => {
  try {
    const url = new URL(targetUrl, origin);
    if (url.origin !== origin) return null;
    const path = url.pathname + url.search + url.hash;
    if (path === '/' || path === current) return null;
    return path;
  } catch {
    return null;
  }
};
